module.exports = __webpack_public_path__ + "images/mdj/members/resume/quick_resume/recruit_daijob_logo-8079b612c6ebd18a3d2f819407ef8dcd.png";